import { ButtonVariant } from "@zanichelli/albe-web-components";
import { ZButton } from "@zanichelli/albe-web-components/react/components";
import i18next from "i18next";
import React from "react";
import { WotdFormData } from "../../../beans/api";
import { IWotdFormDataSet } from "../../store/WotdFormData/actions";
import CheckboxesComponent from "../CheckboxesComponent";
import Content from "../Content";
import { Wrap } from "./styles";

type Props = {
  checkboxes: null | WotdFormData["words"];
  handleCheckboxes: (
    wotdCheckboxes: WotdFormData["words"] | WotdFormData["personalData"],
  ) => IWotdFormDataSet;
};

const WotdSelection: React.FC<Props> = ({ checkboxes, handleCheckboxes }) => {
  const selectAll: WotdFormData["words"] = {
    wordZingarelli: true,
    wordRagazzini: true,
    wordBoch: true,
    wordGkte: true,
    wordSpagnolo: true,
  };

  const deselectAll: WotdFormData["words"] = {
    wordZingarelli: false,
    wordRagazzini: false,
    wordBoch: false,
    wordGkte: false,
    wordSpagnolo: false,
  };
  return (
    <Wrap>
      <Content>{i18next.t("newwotd.checkboxes.title")}</Content>
      <CheckboxesComponent
        checkboxes={checkboxes}
        handleCheckboxes={handleCheckboxes}
        labels={[
          "newwotd.checkboxes.label.italian",
          "newwotd.checkboxes.label.english",
          "newwotd.checkboxes.label.french",
          "newwotd.checkboxes.label.german",
          "newwotd.checkboxes.label.spanish",
        ]}
      />
      <div className="buttons">
        <ZButton
          onClick={() => handleCheckboxes(selectAll)}
          variant={ButtonVariant.SECONDARY}
        >
          {i18next.t("newwotd.checkboxes.button.selectall")}
        </ZButton>
        <ZButton
          onClick={() => handleCheckboxes(deselectAll)}
          variant={ButtonVariant.TERTIARY}
        >
          {i18next.t("newwotd.checkboxes.button.deselectall")}
        </ZButton>
      </div>
    </Wrap>
  );
};

export default WotdSelection;
